<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2 mat-dialog-title appLifecycleTracker trackerName="delete-organization-dialog">{{'ORG_DELETE' | translate}}</h2>

<div mat-dialog-content>
    <mat-form-field class="group-selection" appearance="outline">
        <mat-label>{{'ORG_ORG' | translate}}</mat-label>
        <mat-select [(ngModel)]="selectedGroup">
            <mat-option *ngFor="let group of groups" [value]="group">{{ group.name || group.contact_email }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div mat-dialog-actions class="button-wrapper">
    <button mat-raised-button (click)="onClose()" [disabled]="processing$ | async" type="button">{{'CANCEL' | translate}}</button>
    <button mat-raised-button (click)="onSubmit()" [disabled]="processing$ | async" type="button" color="primary">
        {{'DSS_DELETE' | translate}}
        <span *ngIf="processing$ | async">
            <span class="mdi mdi-dots-circle mdi-spin title-icon"></span>
        </span>
    </button>
</div>
